module.exports = __webpack_public_path__ + "img/IMG_1458_L.6f0e3bd5.webp";